import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { HandleError, HttpErrorHandler } from 'src/app/http-error-handler.service';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
import { JwtService, User, UserService } from 'src/app/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Invoice } from 'src/app/modelo/Invoice';
@Injectable()
export class FAZILService {

    private apiServer = '';

    private handleError: HandleError;
    
    private facturaSource$ = new BehaviorSubject<Invoice>(new Invoice());

    constructor(
        private router: Router,
        private apiService: ApiService,
        private httpClient: HttpClient,
        private httpErrorHandler: HttpErrorHandler,
        private userService: UserService,
        private jwtService: JwtService,
    ) {
        this.apiServer = environment.settings.apiServer;
        this.handleError = httpErrorHandler.createHandleError('FAZILService');
    }
    
    /**
    * Lista de tareas para los roles del usuario autenticado
    */
    
    async pingData(): Promise<any>  {
        return this.ping().toPromise();
    }
    
    ping() {
        return this.apiService.get(this.apiServer + '/ping')
            .pipe( map(data => data),
                catchError(this.handleError('FAZILService.ping'))
            )
    }
    
    getClienteVersionNumber():number{
        const versionNumber:number = + this.jwtService.getVersion();
        return versionNumber;
    }
    
    setClienteVersionNumber(versionNumber:number){
        this.jwtService.saveVersion('' + versionNumber);
    }

    /**
    * Lista de tareas para los roles del usuario autenticado
    */
    getTareasPermisos(routerLink: string) {
        //let routerLink2 = routerLink.replace("/", ":");
        let re = /\//gi;
        let routerLink2 = routerLink.replace(re, ":");
        return this.apiService.get(this.apiServer + '/tareas/routerlink/' + routerLink2)
            .pipe(
                catchError(this.handleError('MSCService.getTareasPorRuta'))
            )
    }
    /**
    * Lista de tareas para los roles del usuario autenticado
    */
    getTareasPermisosUsuario() {
        return this.apiService.get(this.apiServer + '/tareas/permisos')
            .pipe(
                catchError(this.handleError('MSCService.getTareasPermisosUsuario'))
            )
    }

    async irALogin() {
        //Forzar a login
        this.userService.purgeAuth();
        this.router.navigateByUrl('/login');
    }

    async irAInicio() {
        this.router.navigateByUrl('/fazil/facturas');
    }
    
    async irAInicioModulo(modulo:string) {
        this.router.navigateByUrl('/fazil/' + modulo);
    }
    
    async irAInicioNotasdeCredito() {
        this.router.navigateByUrl('/fazil/facturas/notasdecredito');
    }
    async irAInicioRetenciones() {
        this.router.navigateByUrl('/fazil/facturas/retenciones');
    }

    async irAFactura() {
//        this.router.navigateByUrl('/fazil/facturas/factura')
//          .then(() => {
//            window.location.reload();
//          });
        this.router.navigateByUrl('/fazil/facturas/factura');
    }
    async irAProforma(modulo:string) {
//        this.router.navigateByUrl('/fazil/pos/' + modulo + '/proforma')
//          .then(() => {
//            window.location.reload();
//          });
        this.router.navigateByUrl('/fazil/pos/' + modulo + '/proforma');
    }
    
    async irANotaDeCredito() {
        this.router.navigateByUrl('/fazil/facturas/notasdecredito/notadecredito')
          .then(() => {
            window.location.reload();
          });
    }
    async irARetencion() {
        this.router.navigateByUrl('/fazil/facturas/retenciones/retencion')
          .then(() => {
            window.location.reload();
          });
    }

    async irAPerfil() {
        this.router.navigateByUrl('/fazil/perfil');
    }

    async irAInformacionSRI() {
        this.router.navigateByUrl('/fazil/perfil/sri');
    }

    async irARegistrarCertificadoDigital() {
        this.router.navigateByUrl('/fazil/perfil/firma');
    }
    
    async irAAceptarTerminosCondiciones() {
        this.router.navigateByUrl('/fazil/perfil');
    }

    async irAContactos() {
        this.router.navigateByUrl('/fazil/contactos');
    }

    async irAProductosServicios() {
        this.router.navigateByUrl('/fazil/servicios');
    }

    async irALanding() {
        this.router.navigateByUrl('/fazil/planes');
    }

    async irARegistrar() {
        this.router.navigateByUrl('/registrar');
    }

    async irACambiarContrasenia() {
        this.router.navigateByUrl('/login/v2');
    }

    async irAResetContrasenia() {
        this.router.navigateByUrl('/login/v2/perfil');
    }
    

    async irADashboard() {
        this.router.navigateByUrl('/fazil-console/administracion/dashboard');
    }
    
    async irASuscripciones() {
        this.router.navigateByUrl('/fazil-console/administracion/planesorganizacion');
    }
    
    registrarFactura(data:Invoice){
        this.facturaSource$.next(data);
    }
    
    getFactura(): Observable<Invoice> {
        return this.facturaSource$.asObservable();
    }
    
}
